import { Network } from 'lucide-react'
import {
  modelDisplayName,
  previewTeam,
} from '@/features/agents-marketing/data/agentsContent'
import { cn } from '@/lib/utils'

/**
 * Narrow-viewport stand-in for the React Flow canvas: the 740px-wide
 * three-across layout had to be scaled to ~0.4x to fit a phone, leaving
 * unreadable text. Same team, same advise/delegate language, stacked.
 */
export function AgentTeamCompactList() {
  const { coordinator, specialists } = previewTeam

  return (
    <div className="bg-[var(--color-bg-primary)]/50 p-4">
      <div className="surface-bevel rounded-2xl border-primary/60 px-3.5 py-3">
        <div className="flex items-center gap-2">
          <Network className="size-3.5 text-primary" strokeWidth={1.75} />
          <span className="eyebrow text-[10px] text-primary">Coordinator</span>
        </div>
        <p className="mt-1.5 font-mono text-caption text-[var(--color-text-primary)]">
          {modelDisplayName(coordinator.modelId)}
        </p>
      </div>

      <ul className="mt-3 ml-4 space-y-2 border-l border-[var(--color-border-strong)] pl-4">
        {specialists.map((agent) => {
          const delegate = agent.mode === 'delegate'
          return (
            <li key={agent.label} className="surface-bevel rounded-2xl px-3.5 py-3">
              <div className="flex items-center justify-between gap-2">
                <span className="truncate text-body-sm font-semibold text-[var(--color-text-primary)]">
                  {agent.label}
                </span>
                <span
                  className={cn(
                    'eyebrow shrink-0 text-[10px]',
                    delegate && 'text-[var(--color-info-text)]',
                  )}
                >
                  {delegate ? 'Delegates' : 'Advises'}
                </span>
              </div>
              <p className="mt-0.5 truncate font-mono text-caption text-[var(--color-text-tertiary)]">
                {modelDisplayName(agent.modelId)}
              </p>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
